import React from "react";
import { useNavigate } from "react-router-dom";

const HomeContactUs = () => {
  const navigate = useNavigate();

  const handleContactUsButtonClick = (params) => {
    navigate("/contact-us");
  };
  return (
    <div className="min-h-[60vh] bg-gradient-to-br from-[#9F9CFF] to-[#5E5ADB] px-4 md:px-8 lg:px-16 font-tahoma relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      <div className="relative z-10 flex flex-col justify-center items-center gap-6 py-16 md:py-24">
        <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-white text-center font-bold leading-tight max-w-4xl">
          Redefining Media Sharing with{" "}
          <span className="block md:inline">Unparalleled Security and Control</span>
        </h1>
        <p className="text-lg md:text-xl text-white/90 text-center max-w-2xl mt-4">
          Experience the future of secure file sharing with enterprise-grade protection
        </p>
        <button
          onClick={handleContactUsButtonClick}
          className="bg-white hover:bg-[#FAF8F7] text-[#131149] rounded-xl py-3.5 px-8 md:py-4 md:px-10 text-base md:text-lg font-semibold shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1 mt-6"
        >
          Contact Us
        </button>
      </div>
    </div>
  );
};

export default HomeContactUs;
